import { render, staticRenderFns } from "./dialogTipoCobro.vue?vue&type=template&id=e26542bc"
import script from "./dialogTipoCobro.vue?vue&type=script&lang=js"
export * from "./dialogTipoCobro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports